import React from 'react';

import { useIntl } from 'react-intl';

import { IServerOrder } from '@rbi-ctg/menu';
import useMediaQuery, { MediaQuery } from 'hooks/use-media-query';
import { OrderIssues } from 'pages/order-confirmation/common';
import Map from 'pages/order-confirmation/map';
import { useDeliveryConfirmationContext } from 'state/delivery-confirmation';
import { LaunchDarklyFlag, useFlag } from 'state/launchdarkly';

import DeliveryDetails from './delivery-details';
import DeliveryDisclaimer from './delivery-disclaimer';
import {
  DeliveryConfirmationRoot,
  FixedMapWindow,
  ScrollContainer,
  StyledOrderIssues,
} from './styled';

const DeliveryConfirmation: React.FC<{
  serverOrder: IServerOrder | null;
  isInsideModal?: boolean;
}> = ({ serverOrder, isInsideModal }) => {
  const { formatMessage } = useIntl();
  const isShowingOrderingIssue = useFlag(LaunchDarklyFlag.SHOW_ORDERING_ISSUE);

  const { bringgUuids } = useDeliveryConfirmationContext();
  const isMobile = useMediaQuery(MediaQuery.Mobile);
  const isDeliveryDesktop = !(isInsideModal || isMobile);

  if (!serverOrder?.delivery) {
    return <p role="status">{formatMessage({ id: 'errorLoadingUserOrders' })}</p>;
  }

  return (
    <DeliveryConfirmationRoot>
      <FixedMapWindow isDeliveryDesktop={isDeliveryDesktop}>
        <Map bringgUuids={bringgUuids} serverOrder={serverOrder} />
      </FixedMapWindow>

      {!isDeliveryDesktop && (
        <ScrollContainer>
          {serverOrder.delivery && <DeliveryDetails serverOrder={serverOrder} />}
          {isShowingOrderingIssue && (
            <StyledOrderIssues>
              <OrderIssues>
                <DeliveryDisclaimer />
              </OrderIssues>
            </StyledOrderIssues>
          )}
        </ScrollContainer>
      )}
    </DeliveryConfirmationRoot>
  );
};

export default DeliveryConfirmation;
